
import React from 'react';
import { Family } from '@/types/models';
import BillingStatusBadge from '../BillingStatusBadge';

interface FamilyInformationProps {
  family: Family;
}

const FamilyInformation = ({ family }: FamilyInformationProps) => {
  return (
    <div className="space-y-4">
      <div>
        <div className="text-sm font-medium text-muted-foreground">Family Name</div>
        <div className="text-lg font-semibold">{family.name}</div>
      </div>
      
      <div>
        <div className="text-sm font-medium text-muted-foreground">Billing Status</div>
        <div>
          <BillingStatusBadge status={family.billing_status || "inactive"} />
        </div>
      </div>
      
      <div>
        <div className="text-sm font-medium text-muted-foreground">Created</div>
        <div>
          {new Date(family.created_at).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default FamilyInformation;
